import * as React from "react";
import * as ReactDOM from "react-dom";


interface IProperties
{
    children?: any;
    style?: any;
}

export class InputError extends React.Component<IProperties>
{
    render()
    {
        return (
            <div
                className="input-error"
                style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}